export default "__VITE_PUBLIC_ASSET__44b5a636__"